import apollo from '@/graphql'

import DealListQuery from '@/graphql/deal/DealList.gql'

// initial state
const state = {
  dealListLoading: false,
  deals: [],
}

// getters
const getters = {
  dealListLoading: st => st.dealListLoading,
  deals: st => st.deals,
}

// mutations
const mutations = {
  setDealListLoading(st, loading) {
    state.dealListLoading = loading
  },
  setDeals(st, deals) {
    state.deals = deals
  },
}

// actions
const actions = {
  async loadDeals({ commit }) {
    commit('setDealListLoading', true)
    const { data: { allDeals } } = await apollo.defaultClient
      .query({
        fetchPolicy: 'network-only',
        query: DealListQuery,
      })

    commit('setDeals', allDeals)
    commit('setDealListLoading', false)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/deal/DealList.js